/* @flow */
import Row from 'components/UIKit/Flex/Row';
import Column from 'components/UIKit/Flex/Column';
import { SpinnerOverlay } from 'components/UIKit/Spinner';
import Pagination from 'components/Pagination';
import Toolbar from 'components/UIKit/Toolbar';
import { pluralize } from 'constants/plural';
import { parsePaginationParams } from 'utils/location';
import EmptyTableView from './EmptyTableView';

type TableViewProps = {
  entity: string,
  height: number,
  hidePagination: bool,
  IconComponent(props: Object): React.Element,
  list: Object,
  order: string,
  router: Object,
  sort: string,
  subtitle?: string,
  TableComponent: Object,
  title?: string,
  ToolbarComponent(props: Object): React.Element,
}

const TableView = ({
  download,
  entity,
  height,
  hidePagination,
  IconComponent,
  list,
  order,
  path,
  router,
  sort,
  subtitle,
  title,
  TableComponent,
  ToolbarComponent,
  width,
}: TableViewProps): React.Element => {
  const { first } = parsePaginationParams(router);

  return (
    <Row style={{ flex: 1, height, width }}>
      <Column style={{ flex: 1 }}>
        {path === 'qc'
          ? (
            <ToolbarComponent
              download={download}
              list={list}
              path={path}
              router={router}
              subtitle={subtitle}
              title={title || pluralize(entity)}
              />
          )
          : (
            <Toolbar title={pluralize(entity)}>
              <ToolbarComponent
                entity={entity}
                list={list}
                router={router}
                />
            </Toolbar>
          )
        }

        <Column style={{ flex: 1, minHeight: 0 }}>
          <SpinnerOverlay isLoading={list.isFetching}>
          {list.data.items && list.data.items.length
            ? (
              <Column style={{ flex: 1, minHeight: 0 }}>
                <Row className="entity-table pdf-display-block" style={{ overflowY: 'scroll', flex: 1 }}>
                  <TableComponent
                    descriptions={list.data.summary}
                    IconComponent={IconComponent}
                    order={order}
                    router={router}
                    sort={sort}
                    >
                    {list.data.items}
                  </TableComponent>
                </Row>

                {hidePagination || (
                  <Pagination
                    total={list.data.count || list.data.items.length}
                    router={router}
                    size={first}
                    entity={entity}
                    />
                )}
              </Column>
            )
            : list.isFetching || EmptyTableView({ entity, IconComponent })
          }
          </SpinnerOverlay>
        </Column>
      </Column>
    </Row>
  );
};

export default TableView;
